const coerceBool = value => value === true || value === 'true';

export default coerceBool;
